import Vue from 'vue'
import ja from './ja'
import en from './en'
import ElementLocale from 'element-ui/lib/locale'
import elementJa from 'element-ui/lib/locale/lang/ja'
import elementEn from 'element-ui/lib/locale/lang/en'

const STORAGE_KEY = 'searchplusplus_lang'

const dicts = { ja, en }
const state = Vue.observable({ lang: 'ja' })

function readDict (key, lang) {
  const dict = dicts[lang] || {}
  return key.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), dict)
}

function interpolate (value, params) {
  if (typeof value !== 'string' || !params) return value
  return value.replace(/\{(\w+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match)
}

const i18n = {
  get lang () {
    return state.lang
  },
  t (key, params) {
    let value = readDict(key, state.lang)
    if (value == null && state.lang !== 'ja') {
      value = readDict(key, 'ja')
    }
    if (Array.isArray(value)) {
      return value.map(item => interpolate(item, params))
    }
    return interpolate(value, params)
  },
  switchLang (lang) {
    if (!dicts[lang] || lang === state.lang) {
      if (dicts[lang]) this.applyExternal(lang)
      return
    }
    state.lang = lang
    this.applyExternal(lang)
  },
  applyExternal (lang) {
    ElementLocale.use(lang === 'en' ? elementEn : elementJa)
    try {
      localStorage.setItem(STORAGE_KEY, lang)
    } catch (e) { /* ignore */ }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang === 'en' ? 'en' : 'ja'
    }
  },
  init () {
    let saved = null
    try {
      saved = localStorage.getItem(STORAGE_KEY)
    } catch (e) { /* ignore */ }
    if (saved && dicts[saved]) {
      state.lang = saved
      this.applyExternal(saved)
    } else {
      this.applyExternal('ja')
    }
  }
}

Vue.prototype.$t = function (key, params) {
  return i18n.t(key, params)
}

Object.defineProperty(Vue.prototype, '$lang', {
  get () {
    return state.lang
  }
})

Vue.prototype.$switchLang = function (lang) {
  i18n.switchLang(lang)
}

export default i18n
